module.exports = __webpack_public_path__ + "static/National2Web-Regular-ca82c9414691179af5bfdbbfbed9193e.woff";